import React from "react";
import PropTypes from "prop-types";
// Constant
import { IMAGES } from "../constants";

const greetingMapMessage = {
  signIn: "Welcome back, sign in to your account.",
  signedUp: "Welcome back, sign in to your account.",
  signedOut: "Welcome back, sign in to your account.",
  signUp: "Create a new account.",
  forgotPassword: "Forgot your password.",
  resetPassword: "Reset you password.",
  accountConfirm: "Verify your account.",
  newPasswordRequired: "Setup your account",
};

const CustomGreetings = ({ authState }) => {
  const isNewPasswordRequired = authState === "newPasswordRequired";
  return (
    <div className="auth-greeting">
      <img
        className={isNewPasswordRequired ? "" : "logo"}
        src={isNewPasswordRequired ? IMAGES.ONBOARDING_LOGO : IMAGES.APP_LOGO}
        alt="logo"
        {...(isNewPasswordRequired && {
          width: "291",
          height: "85",
        })}
      />
      <h2
        className={
          isNewPasswordRequired ? "auth-new-password-heading" : "auth-heading"
        }
      >
        {greetingMapMessage[authState]}
      </h2>
    </div>
  );
};

CustomGreetings.propTypes = {
  authState: PropTypes.string,
};

export default CustomGreetings;
